import { render, staticRenderFns } from "./MyPhotos.vue?vue&type=template&id=1c54ffc0&scoped=true&"
import script from "./MyPhotos.vue?vue&type=script&lang=js&"
export * from "./MyPhotos.vue?vue&type=script&lang=js&"
import style0 from "./MyPhotos.vue?vue&type=style&index=0&id=1c54ffc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54ffc0",
  null
  
)

export default component.exports